import type { NotificationCardProps } from "./notification-card.type";

import { Flex, Tooltip, Typography } from "antd";
import classNames from "classnames";

import { format, fromNow } from "@/utilities/date";

import { useNotificationCard } from "./notification-card.hook";

import "./notification-card.style.less";

const { Title, Text } = Typography;

export const NotificationCard = ({
  notification,
  icon,
  title,
  color,
  subTitle,
  content,
  actions,
}: NotificationCardProps) => {
  const { isUnread, isPending, onCardClick } =
    useNotificationCard(notification);
  const titleColor = isUnread ? color : undefined;

  return (
    <div
      onClick={onCardClick}
      className={classNames("notification-card", {
        "-unread": isUnread,
        "-pending": isPending,
      })}
    >
      <Flex gap="small" align="center" className="notification-card-header">
        <div className="notification-card-icon">{icon}</div>
        <Flex gap="small" align="center" className="notification-card-title">
          <Title level={3} style={{ color: titleColor }} ellipsis>
            {title}
          </Title>
          {subTitle && (
            <>
              <Text>•</Text>
              <Text className="notification-card-subtitle" ellipsis>
                {subTitle}
              </Text>
            </>
          )}
        </Flex>
        <div className="notification-card-date">
          <Tooltip title={format(notification.created_at, "LLLL")}>
            {fromNow(notification.created_at)}
          </Tooltip>
        </div>
        <div className="notification-card-indicator" />
      </Flex>
      <div className="notification-card-content">
        {content}
        {actions && (
          <Flex gap="middle" align="center">
            {actions}
          </Flex>
        )}
      </div>
    </div>
  );
};
